import { Component, OnInit, ViewChild } from '@angular/core';
import { AgendasService } from '../../services/agendas.service';
import { DatabaseService } from '@app/database/database.service';
import { DataView } from 'primeng/dataview';
import moment from 'moment';
import { PaginationService } from '../../services/pagination.service';


const PENDIENTES = 'pendientes';
@Component({
  selector: 'app-agendas',
  templateUrl: './agendas.component.html',
  styleUrls: ['./agendas.component.scss']
})
export class AgendasComponent implements OnInit {

  displayModal: boolean = false;
  displaySpinner = true;
  listaAgendas: [] = [];
  isConnected: boolean = true;
  isAgenda: boolean = true;
  estado: string;
  @ViewChild('dv', { static: false }) dataview: DataView;
  sinRegistroFilter : boolean = false;
  filterBy = 'numeroLote,contrato,establecimiento,empresa,cuit,fecha,fechaInicio,fechaFin';
  inputSearch: string;
  display: boolean;
  clearFilter = false;
  fecha: string;
  currentPage: number;
  rows: number;

  constructor(private agendasService: AgendasService,
              private databaseService: DatabaseService,
              private paginationService: PaginationService) {}

  ngOnInit() {
    this.currentPage = this.paginationService.currentPage;
    this.rows = this.paginationService.rowsPerPage;

    if (this.currentPage===1){
      this.isOnline().then(
        (value) => {
          if (!value){
            this.isConnected=false;
          }
      });
      this.getListAgendas(PENDIENTES);
    }
    this.estado = PENDIENTES.slice(0, -1);
  }

  onPageChange(event) {
    this.paginationService.setPage(event.first);
    this.currentPage = this.paginationService.currentPage;
  }

  onRowsPerPageChange(event) {
    this.paginationService.setRowsPerPage(event.value);
  }

  actionFilter(event): void {

    if (event.target.value === undefined || event.target.value === null) {
      this.sinRegistroFilter = false;
      return;
    }
    if (event.target.value === '') {
      this.sinRegistroFilter = false;
    }
    this.dataview.filter(event.target.value);
    setTimeout(() => {
      if (event.target.value) {
        this.sinRegistroFilter =
          this.dataview.filteredValue &&
          this.dataview.filteredValue.length <= 0;
      }
    }, 100);
  }

  showModalFilter( event: any ): void {
    this.displayModal = true;
  }

  closeModal(): void {
    this.displayModal = false;
  }

  async onFilterAgendas(event) {
    this.displaySpinner=true;
    this.listaAgendas=[];
    await this.getListAgendas(event);
    this.closeModal();
  }

  async getListAgendas(event) {
    try {
      const online = await this.isOnline();
      if (online) {
        const response = await this.agendasService.getCardAgendas(event).toPromise();
        if(response.body.response) {
          const lista = response.body.response.lotes;
          this.estado = event.slice(0, -1);
          this.displaySpinner = false;
          const arrayConFechasReemplazadas  = lista.map(objeto => {
            this.fecha = moment(objeto.fecha).format('DD/MM/yyyy');
            return  {
              ...objeto,
              fecha: this.fecha
            };
          });
          this.listaAgendas = arrayConFechasReemplazadas;
        }else{
          this.displaySpinner = false;
        }
        
      }else{
        this.displaySpinner = false;
      }
    } catch (e) {
      console.error('Error:', e);
    }
  }

  private async isOnline(): Promise<boolean> {
    const isOnline = await (
      await this.databaseService.getOnlineStatusFromOfflineDB()
    ).isStillOnline;

    this.isConnected = isOnline;
    return isOnline;
  }

  async clearFiltro() {
    await this.onFilterAgendas(PENDIENTES);
    this.clearFilter = false;
  }

  seeClearFilter(event){
    this.clearFilter=event;
  }

}
